export default {
  props: {
    labels: {
      type: Object,
      default: () => {},
    },
  },
  provide() {
    return {
      labels: this.labels,
    };
  },
};
